(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/shares', {
      templateUrl: 'modules/app/settings/shares/shares.html',
      controller: 'SharesListerCtrl',
      requiredPermissions: ['admin', 'manager']
    });
  }]).controller('SharesListerCtrl', ['$controller', '$scope', 'Api', 'Alerts', '$http', 'wsEventNames', '$q', 'UserRoles', 'User', '$timeout', '$location', 'OrganizationSettings', 'ShareNav', function ($controller, $scope, Api, Alerts, $http, wsEventNames, $q, UserRoles, User, $timeout, $location, OrganizationSettings, ShareNav) {
    $scope.section = "shares";
    $scope.isLoading = {
      query: true,
      page: true
    };
    $scope.pageSize = 10;
    $scope.showPager = false;
    $scope.hidePageSize = false;
    $scope.limit = 0;
    $scope.offset = 0;
    $scope.pages = [];
    $scope.pageNumber = 1;
    $scope.resultCount = 0;
    $scope.currentListing = [];
    $scope.minPage = $scope.currentListing.length > 0 ? 1 : 0;
    $scope.maxPage = $scope.pages[$scope.pages.length - 1];
    var user = User.get();
    $scope.canEdit = UserRoles.isOrgAdmin(user) || UserRoles.isOrgManager(user);
    $scope.organizationId = user.organization.id;
    $scope.sortControls = [{
      "title": "Report Title",
      "options": {
        "Ascending": "card_title",
        "Descending": "-card_title"
      }
    }, {
      "title": "Share Count",
      "options": {
        "Ascending": "share_count",
        "Descending": "-share_count"
      }
    }, {}];
    var prevSearchTerm = '';
    $scope.updateSearchTerm = function updateSearchTerm(searchTerm) {
      $scope.searchTerm = searchTerm;
      if ($scope.searchTerm !== prevSearchTerm) {
        $scope.$broadcast(wsEventNames.pager.setPage, 1);
        $scope.fetch();
        prevSearchTerm = $scope.searchTerm;
      }
    };
    $scope.buildSearchParams = function buildSearchParams() {
      var params = {};
      params.searchText = $scope.searchTerm;
      params._limit = $scope.pageSize;
      params._offset = ($scope.pageNumber - 1) * $scope.pageSize;
      params.organization_id = $scope.organizationId;
      if ($scope.sortBy && $scope.sortBy.length > 0) {
        params.order_by = $scope.sortBy;
      }
      return params;
    };
    $scope.defaultSearchBy = ["key", "title"];
    $scope.searchBy = "title";
    $scope.defaultSortBy = "id";
    $scope.sortBy = "id";
    $scope.apiUrl = Api.url("/shares/count-by-card?organization_id=" + $scope.organizationId, true);
    $scope.roles = [{
      name: "watershed-partner",
      description: "Watershed Partner"
    }];
    $scope.changeShares = function changeShares(card) {
      $scope.savedCard = card;
      $scope.card = card.card;
      $scope.hasCard = true;
      ShareNav.shareCard($scope).createShareModal(card.card.id);
    };
    $scope.$on("app-create-share", function () {
      if ($scope.savedCard) {
        $scope.savedCard.shareCount += 1;
      }
    });
    $scope.$on("app-delete-share", function () {
      if ($scope.savedCard) {
        $scope.savedCard.shareCount -= 1;
      }
    });
    $scope.fetch = function fetch() {
      /*jshint camelcase: false */
      var params = $scope.buildSearchParams();
      $scope.loading = true;
      return $scope.fetchData(params).then(function (data) {
        if (!data) {
          return;
        }
        $scope.data = data;
        $scope.currentListing = data.results;
        $scope.resultCount = data.count;

        // Result count is based ona distinct count using cardinality.  This uses the default
        // ES precision threshold of 3000, so if above 3000 this is an approximation.  Round
        // the number to accentuate that it's an estimate.
        if ($scope.resultCount > 3000) {
          $scope.resultCount = Math.round($scope.resultCount / 100) * 100;
          $scope.resultCountRounded = true;
        }

        // Don't allow deep paging
        if ($scope.resultCount >= 10000) {
          $scope.hideLastPageLink = true;
        }
        $scope.resetPageListing();
        $scope.loading = false;
      }).catch(function (err) {
        throw new Error(err.data ? err.data.exceptionMessage || err.data.message : err);
      });
    };
    $scope.fetchData = function (params) {
      $scope.buildSearchParams();
      $scope.getApiUrl = $scope.getApiUrl || $scope.apiUrl;
      if ($scope.getApiUrl) {
        return $http.get($scope.getApiUrl, {
          params: params
        }).then($scope.processFetchResponse).catch(function (err) {
          return $q.reject(err);
        });
      } else {
        return $q.resolve({
          count: 0,
          results: []
        });
      }
    };
    $controller('ListerModalBaseCtrl', {
      $scope: $scope
    });
  }]).controller('SharesListerItemCtrl', ['$controller', '$scope', '$uibModal', 'Logger', '$http', 'Api', function ($controller, $scope, $uibModal, Logger) {
    $scope.getPostData = function () {
      return $scope.editCopy;
    };
    $scope.deleteSuccessEvent = "org-shares-item-delete";
    $scope.deleteError = function (response) {
      Logger.error("Error deleting share " + $scope.item.id + ", response status " + response.status);
      $scope.deleteErrorMsg = "There was an error deleting the share.";
    };
    $controller('ListerItemCtrl', {
      $scope: $scope
    });
  }]);
})();
